/* eslint-disable react/prop-types */
import React, { Component } from "react";
import { Header, Form, Button, Segment } from "semantic-ui-react";
import { withRouter } from "react-router-dom";
import Constants from "../utilities/Constants";
import Strings from "../utilities/StringSelector";
import Utils from "../utilities/Utils";
import sha256 from "js-sha256";

const UtilsInstance = new Utils();

class Login extends Component {

  handleSubmit = () => {
    let loginData = JSON.stringify({
      login: document.getElementById("login").value,
      password: sha256(document.getElementById("password").value),
    });

    fetch(Constants.REQUEST_IP_ADDRESS + "login_POST", {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      body: loginData
    })
      .then(UtilsInstance.checkStatus)
      .then(() => {
        sessionStorage.auth = Constants.AUTH_STR;
        this.props.history.push({ pathname: "/config" });
      })
      .catch((error) => {
        if (undefined !== error.response) {
          if (error.response.status === 401) {
            alert(Strings.LOGIN_CREDENTIALS_FAILURE);
          }
          else {
            alert(Strings.LOGIN_GENERAL_FALIURE + error);
          }
        }
      });
  }

  render() {
    return (
      <div>
        <Segment style={segmentStyle}>
          <Header as='h2' icon textAlign='center'>{Strings.LOGIN}</Header>
          <Form onSubmit={this.handleSubmit}>
            <Form.Input
              id="login"
              placeholder={Strings.USER}
              name="username"
              type="text"
              autoComplete="off" >
            </Form.Input>
            <Form.Input
              id="password"
              placeholder={Strings.PASSWORD}
              name="password"
              type="password"
              autoComplete="off" />
            <Button color="teal" type="submit" >{Strings.ENTER}</Button>
          </Form>
        </Segment>
      </div >
    );
  }
}

const segmentStyle = {
  textAlign: "center",
  margin: "auto",
  marginTop: "8em",
  width: "24vw"
};

export default withRouter(Login);